import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit, Optional, PLATFORM_ID } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { FerienFIlters } from '@app/models/filtermodels/FerienFIlters';
import { Partner } from '@app/models/partner/IPartner';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { FerienFiltersService } from '@app/services/ferienhauser/ferieneFilters.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MEDIA_TOKEN } from '../../../../../../tockens';
@Component({
    selector: 'clever-ferienhauserfilter',
    templateUrl: './ferienhauserfilter.component.html',
    styleUrls: ['./ferienhauserfilter.component.scss'],
    standalone: false
})
export class FerienhauserfilterComponent implements OnInit, OnDestroy {
    @Input() mode: string;
    @Input() myferienfilters: FerienFIlters;
    @Input() reference: string;
    protected unsubscribe$ = new Subject();

    media: string = 'xl';
    prsText: string = '';

    isBrowser: boolean = false;
    showMore: boolean = false;
    smallVersion: boolean = true;
    btntext: string = 'SUCHEN';
    currentpartner: Partner;

    dauers = [
        {
            name: 'exakt wie angegeben',
            code: '-1'
        },
        {
            name: '1 Nacht',
            code: '1'
        },
    ];

    constructor(
        protected ferienFiltersService: FerienFiltersService,
        protected guardService: AuthGuardService,
        protected mediaObserver: BreakpointObserver,
        protected cdr: ChangeDetectorRef,
        @Inject(PLATFORM_ID) protected platformId: any,
        @Optional() @Inject(MEDIA_TOKEN) private media_token: string
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
        this.media = this.media_token;
    }

    ngOnInit(): void {
        if(this.isBrowser) {
            this.setFilters();
            this.initDauers();
        }
        this.initMedia();
    }

    async initDauers() {
        for (let i = 2; i < 31; i++) {
            this.dauers.push({
                name: i + ' Nächte',
                code: i + ''
            });
        }
    }

    setFilters(): void {
        if (this.myferienfilters) {
            this.myferienfilters.productType = 'ferienhauser';
            this.ferienFiltersService.setFilters(this.myferienfilters);
        }
        this.initPartner();
    }

    async selectDauer(vl) {
        this.ferienFiltersService.reisedauerResult(vl.code);
    }

    async initMedia() {
       if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.media = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.media = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.media = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.media = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.media = 'xl';
        }
        this.cdr.detectChanges();
    }

    async initPartner() {
        this.guardService.getPartner$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((partner) => {
            if (partner?.partnerid?.length > 0) {
                this.currentpartner = partner;
                this.getFilters();
            }
        });
    }

    async getFilters() {
        this.ferienFiltersService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(params => {
            if (params) {
                this.myferienfilters = JSON.parse(JSON.stringify(params));
                const tmp_persons =  this.myferienfilters.adults +  this.myferienfilters.children;
                if (tmp_persons === 1) {
                    this.prsText = tmp_persons + ' Gast';
                } else {
                    this.prsText = tmp_persons + ' Gäste';
                }
            }
        });
    }

    selectDateValue(ev): void {
        this.ferienFiltersService.reisezeitraumResult({ start: ev.start, end: ev.end });
    }

    gotoZiel(): void {
        this.smallVersion = true;
        this.ferienFiltersService.gotoUrl();
    }

    openclosemore(): void {
        this.showMore = !this.showMore;
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    openMap(ev) {
        ev.stopPropagation();
        this.ferienFiltersService.openMapModal();
    }

    showMBMenu(): void {
        this.smallVersion = false;
    }
}
